export const PHONE_COUNTRY_CODE = {
  AU: '61',
} as const;
